Vue.component('cobrowsing-prompt', {
	props: ['options'],
	template:
		'<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutDown" v-bind:css="options.internal.isAnimationCompatibility">' +
		'	<div id="cobrowsing-prompt" class="panel-widget">' +
		'		<div class="overlay-content text-center">' +
		'			<h3>{{ prompt.title }}</h3>' +
		'		</div>' +
		'		<div class="overlay-footer">' +
		'			<div v-for="(item, index) in prompt.choices" class="col-xs-6">'+
		'				<span @click="onChoiceClick(item)" class="btn" v-bind:class="alignChoices(index, item.value)">{{ item.text }}</span>'+
		'			</div>' +
		'		</div>' +
		'	</div>' +
		'</transition>',
	data: function () {
		return {
			isActive: false,
			timeShow: true,
			choice: false,
			id: null,
			prompt: null
		}
	},
	created: function () {},
	mounted: function () {
		bus.$emit("log-event", { level: "INFO", message: "CobrowsingPrompt.js - Mounting cobrowsing prompt" });

		this.id = Date.now();
		this.$parent.$on("showCobrowsingPrompt", function(promptData) {
			bus.$emit("log-event", { level: "INFO", message: "CobrowsingPrompt.js - Showing cobrowsing prompt for: " + JSON.stringify(promptData) });
			this.prompt = promptData;
			this.isActive = true;
		}.bind(this))

		this.$parent.$on("hideCobrowsingPrompt", function() {
			bus.$emit("log-event", { level: "INFO", message: "CobrowsingPrompt.js - Hiding cobrowsing prompt" });
			this.isActive = false;
			this.prompt = null;
		}.bind(this))

		bus.$on("closeCobrowsingPrompt_" + this.id, function(value) {
			//bus.$emit("log-event", { level: "INFO", message: "CobrowsingPrompt.js - Closing cobrowsing prompt with id " + this.id });
			this.choice = value;
			this.isActive = false;
		}.bind(this))
	},
	methods: {
		getImgAgent: function (val) {
			if (val == "virtual") {
				return this.options.imgVirtualAgent;
			} else {
				return this.options.imgAgent;
			}
		},
		onChoiceClick: function(choice) {
			bus.$emit('onCobrowsingResponse', {"value" : choice.value, "id" : this.id});
		},
		setClassAgent: function (val) {
			return val;
		},
		// Lascito di Bruno Pistone (22/02/2019 - 11:51) - Si prega di non cancellare
		alignChoices: function(index, buttonValue) {
			switch(buttonValue) {
				case true:
					var classes = "btn-info";
					return (index % 2 == 0) ? classes + " pull-left" : classes + " pull-right";
				case false:
				default:
					return (index % 2 == 0) ? "pull-left" : "pull-right";
			}
		}
		// * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * //
	}
})